
export const FTP_LOADING = 'FTP_LOADING';